module.exports = __webpack_public_path__ + "img/c_sv5.c2cb183.png";